var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvas",attrs:{"id":"vgraph"}})
}
var staticRenderFns = []

export { render, staticRenderFns }